<yc-table
  [key]="tableKey"
  [rows]="rows"
  [rowsPerPage]="isSimple ? 5 : 15"
  [hideTableFilters]="isSimple"
  [simple]="isSimple"
  [drilldownStyles]="isSimple"
  [topLevelFilters]="topLevelFilters"
  [tableDownloadFactory]="isSimple ? undefined : tableDownloadFactory">

  <!-- Date -->
  <ng-container *ycTableColumn="'common:hdrDate';
    let row;
    prop: 'createdDate'
    filterType: 'date'">
    {{ row.createdDate | ycFormatDate }}
    <div *ngIf="isSimple">
      {{ row.createdByUserName }}
    </div>
  </ng-container>

  <!-- Detail -->
  <ng-container *ycTableColumn="'common:hdrDetail';
    let row;
    prop: 'actionType'">
    {{ row.actionMessage }}
  </ng-container>

  <!-- User -->
  <ng-container *ycTableColumn="'common:hdrUser';
    let row;
    visible: !isSimple,
    prop: 'createdByUserName',
    filterType: 'text'">
    {{ row.createdByUserName }}
  </ng-container>

  <!-- Impact -->
  <ng-container *ycTableColumn="'common:hdrImpact';
    let row;
    prop: 'impactAmount',
    filterType: 'number'">
    <span [ngClass]="row.impactColor">
      {{ row.impactDisplay }}
    </span>
  </ng-container>

</yc-table>